import Header from "./Header/Header"
import Footer from "./Footer/Footer"
import ScrollToTopBtn from "./ScrollToTopBtn/ScrollToTopBtn"

const Layout =({children})=>{
    return (
      <div className="layout">
        <Header />
        <main className="content">{children}</main>
        <Footer />
        <ScrollToTopBtn />
      </div>
    );
}

export default Layout